module.exports = __webpack_public_path__ + "static/img/dichan.ac98847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/dichan.jpg
// module id = 388
// module chunks = 12